import {Injectable, OnInit} from '@angular/core';


@Injectable()
export class AccountData implements OnInit {

    email: string;

    ngOnInit(): void {
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/identite-personne/data/account.data.ts